const LEGACY_SIGNING_LOCK_KEY = 'nm.mobileSwapSigningLock'
const SIGNING_LOCK_KEY = 'nm.walletSigningLock'
const SIGNING_LOCK_MAX_AGE_MS = 5 * 60_000

function readLockTimestamp(): number | null {
  if (typeof window === 'undefined') return null
  try {
    const raw =
      window.sessionStorage.getItem(SIGNING_LOCK_KEY) ??
      window.sessionStorage.getItem(LEGACY_SIGNING_LOCK_KEY)
    if (!raw) return null
    const started = Number.parseInt(raw, 10)
    return Number.isFinite(started) ? started : null
  } catch {
    return null
  }
}

export function markWalletSigningLock(now = Date.now()): void {
  if (typeof window === 'undefined') return
  try {
    const value = String(now)
    window.sessionStorage.setItem(SIGNING_LOCK_KEY, value)
    window.sessionStorage.setItem(LEGACY_SIGNING_LOCK_KEY, value)
  } catch {
    /* quota / private mode */
  }
}

export function clearWalletSigningLock(): void {
  if (typeof window === 'undefined') return
  try {
    window.sessionStorage.removeItem(SIGNING_LOCK_KEY)
    window.sessionStorage.removeItem(LEGACY_SIGNING_LOCK_KEY)
  } catch {
    /* ignore */
  }
}

export function isWalletSigningLockActive(now = Date.now()): boolean {
  const started = readLockTimestamp()
  if (started === null) return false
  if (now - started > SIGNING_LOCK_MAX_AGE_MS) {
    clearWalletSigningLock()
    return false
  }
  return true
}

/** Evita reconnect/deeplink a MetaMask durante firma on-chain (swap, liquidez, approve). */
export function shouldBlockWalletReconnect(): boolean {
  return isWalletSigningLockActive()
}
